<div class="bg-white rounded-lg border-[3px] border-border-line" [class.opacity-50]="disabled" [class.pointer-events-none]="disabled">
  <div class="bg-border-line/50 p-3 flex flex-col sm:flex-row gap-3">
    <div class="flex items-center gap-2">
      <img width="88" height="30" class="w-[58px] sm:w-[88px]" src="/assets/images/brand-logo-pathnavi.svg" alt="旺文社パスナビ" />
      <p class="font-bold mb-0 text-xs sm:text-sm">この大学の入試情報をバスナビで調べよう！</p>
    </div>
    <hr class="border-border-line sm:hidden" />
    <div class="flex gap-2 [&_.mat-button-wrapper]:text-sm [&_.mat-button-wrapper]:xs:text-md sm:ml-auto">
      <button
        mat-flat-button
        class="max-sm:grow border border-border-line border-solid"
        [disabled]="disabled"
        (click)="openPassnaviHaiten()"
      >
        <div class="flex gap-1 items-center justify-center">
          <span class="">入試科目・配点</span>
          <mat-icon class="mt-1 text-passnavi-primary" aria-hidden="false" aria-label="">open_in_new</mat-icon>
        </div>
      </button>
      <button
        mat-flat-button
        class="max-sm:grow border border-border-line border-solid"
        [disabled]="disabled"
        (click)="openPassnaviHensati()"
      >
        <div class="flex gap-1 items-center justify-center">
          <span class="">偏差値 ・共テ得点率</span>
          <mat-icon class="mt-1 text-passnavi-primary" aria-hidden="false" aria-label="">open_in_new</mat-icon>
        </div>
      </button>
    </div>
  </div>
</div>
